const RN_PRODUCT_SELECTOR = '[data-rn-product-root]';

function initRnProduct(root) {
  if (!root || root.dataset.rnInitialized === 'true') return;
  root.dataset.rnInitialized = 'true';
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = root.querySelectorAll('[data-rn-reveal], [data-rn-media-reveal]');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        currentObserver.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });
    revealItems.forEach((item) => observer.observe(item));
  }

  const visual = root.querySelector('[data-rn-product-visual]');
  const bottle = root.querySelector('[data-rn-bottle]');
  if (visual && bottle && !reduceMotion && matchMedia('(pointer: fine)').matches) {
    let frame = 0;
    let nextX = 0;
    let nextY = 0;
    const renderTilt = () => {
      frame = 0;
      bottle.style.transform = `rotateX(${nextY}deg) rotateY(${nextX}deg) translate3d(0,0,0)`;
    };
    visual.addEventListener('pointermove', (event) => {
      const bounds = visual.getBoundingClientRect();
      nextX = ((event.clientX - bounds.left) / bounds.width - 0.5) * 7;
      nextY = ((event.clientY - bounds.top) / bounds.height - 0.5) * -5;
      if (!frame) frame = requestAnimationFrame(renderTilt);
    });
    visual.addEventListener('pointerleave', () => {
      if (frame) cancelAnimationFrame(frame);
      frame = 0;
      bottle.style.transform = '';
    });
  }

  const variantSelect = root.querySelector('[data-rn-variant-select]');
  const price = root.querySelector('[data-rn-price]');
  const submit = root.querySelector('.rn-product-form__submit');
  const submitLabel = submit;
  variantSelect?.addEventListener('change', () => {
    const option = variantSelect.selectedOptions[0];
    const available = option?.dataset.available === 'true';
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (submit) submit.disabled = !available;
    if (submitLabel) submitLabel.textContent = available ? root.dataset.addLabel : root.dataset.soldLabel;
    const url = new URL(location.href);
    url.searchParams.set('variant', variantSelect.value);
    history.replaceState({}, '', url);
  });

  const gallery = root.querySelector('[data-rn-product-gallery]');
  if (gallery) {
    const track = gallery.querySelector('[data-rn-product-gallery-track]');
    const slides = [...gallery.querySelectorAll('[data-rn-product-gallery-slide]')];
    const current = gallery.querySelector('[data-rn-product-gallery-current]');
    const previous = gallery.querySelector('[data-rn-product-gallery-prev]');
    const next = gallery.querySelector('[data-rn-product-gallery-next]');
    const thumbnails = [...gallery.querySelectorAll('[data-rn-product-thumbnail]')];
    let activeIndex = 0;
    let pointerStart = null;
    const showSlide = (nextIndex) => {
      activeIndex = (nextIndex + slides.length) % slides.length;
      track.style.transform = `translate3d(${-activeIndex * 100}%,0,0)`;
      slides.forEach((slide, index) => {
        const active = index === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
      });
      thumbnails.forEach((button, index) => { button.classList.toggle('is-active', index === activeIndex); button.setAttribute('aria-pressed', String(index === activeIndex)); });
      if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
    };
    thumbnails.forEach((button, index) => button.addEventListener('click', () => showSlide(index)));
    previous?.addEventListener('click', () => showSlide(activeIndex - 1));
    next?.addEventListener('click', () => showSlide(activeIndex + 1));
    gallery.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); showSlide(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); showSlide(activeIndex + 1); }
    });
    gallery.addEventListener('pointerdown', (event) => { pointerStart = event.target.closest('button') ? null : event.clientX; });
    gallery.addEventListener('pointerup', (event) => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) < 40) return;
      showSlide(activeIndex + (distance < 0 ? 1 : -1));
    });
    gallery.addEventListener('pointercancel', () => { pointerStart = null; });
    showSlide(0);
  }
}

function initAllRnProducts(scope = document) {
  scope.querySelectorAll(RN_PRODUCT_SELECTOR).forEach(initRnProduct);
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAllRnProducts());
else initAllRnProducts();
document.addEventListener('shopify:section:load', (event) => initAllRnProducts(event.target));
